import * as React from 'react'

const RenewProxyConfirmDialog = (props) => {

  const handleClose = () => {
    props.setOpenConfirmRenew(false)
  }

  const calculateRenewPrice = (lease) => {
    const start = new Date(lease.start)
    const until = new Date(lease.until)

    const hours = (until.getTime() - start.getTime()) / 1000.0 / 60.0 / 60.0

    return Math.floor((lease.purchasePriceC / hours) * 24.0)
  }

  const handleRenew = () => {
    try {
        props.renewProxy()
        props.setOpenConfirmRenew(false)
    } catch (e) {
        throw e
    } 
  }

  return (
      <>
          {/* Модальное окно подтверждения продления */}
          {props.openConfirmRenew && (
              <div style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10000
              }} onClick={handleClose}>
                  <div style={{
                      background: 'var(--medium-gray)',
                      border: '1px solid var(--light-gray)',
                      borderRadius: 'var(--radius-lg)',
                      padding: 'var(--spacing-2xl)',
                      maxWidth: '450px',
                      width: '90%',
                      boxShadow: 'var(--shadow-card)',
                      position: 'relative'
                  }} onClick={(e) => e.stopPropagation()}>
                      
                      {/* Кнопка закрытия */}
                      <button
                          onClick={handleClose}
                          style={{
                              position: 'absolute',
                              top: 'var(--spacing-md)',
                              right: 'var(--spacing-md)',
                              background: 'none',
                              border: 'none',
                              color: 'var(--text-muted)',
                              fontSize: 'var(--text-xl)',
                              cursor: 'pointer',
                              padding: '4px'
                          }}
                      >
                          ✕
                      </button>

                      {/* Заголовок */}
                      <h2 style={{
                          color: 'var(--text-light)',
                          fontSize: 'var(--text-2xl)',
                          fontWeight: '700',
                          marginBottom: 'var(--spacing-xl)',
                          textAlign: 'center',
                          background: 'var(--gradient-orange)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                      }}>
                          Renew Proxy Confirm
                      </h2>

                      {/* Информация о продлении */}
                      <div style={{
                          background: 'var(--dark-gray)',
                          border: '1px solid var(--light-gray)',
                          borderRadius: 'var(--radius-md)',
                          padding: 'var(--spacing-lg)',
                          marginBottom: 'var(--spacing-xl)',
                          textAlign: 'center'
                      }}>
                          <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 'var(--spacing-md)',
                              marginBottom: 'var(--spacing-md)'
                          }}>
                              <div style={{
                                  background: 'var(--primary-orange)',
                                  borderRadius: '50%',
                                  width: '48px',
                                  height: '48px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '24px'
                              }}>
                                  🔄
                              </div>
                              <div>
                                  <h3 style={{
                                      color: 'var(--text-light)',
                                      fontSize: 'var(--text-lg)',
                                      fontWeight: '600',
                                      margin: '0 0 var(--spacing-xs) 0'
                                  }}>
                                      Proxy Renewal
                                  </h3>
                                  <p style={{
                                      color: 'var(--text-muted)',
                                      fontSize: 'var(--text-sm)',
                                      margin: '0'
                                  }}>
                                      Extend for 24 hours
                                  </p>
                              </div>
                          </div>

                          <div style={{
                              borderTop: '1px solid var(--light-gray)',
                              paddingTop: 'var(--spacing-md)',
                              marginTop: 'var(--spacing-md)'
                          }}>
                              <p style={{
                                  color: 'var(--text-light)',
                                  fontSize: 'var(--text-base)',
                                  margin: '0 0 var(--spacing-sm) 0',
                                  lineHeight: '1.5'
                              }}>
                                  Proxy will be renewed for next 24 hours
                              </p>
                              <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 'var(--spacing-sm)',
                                  marginTop: 'var(--spacing-sm)'
                              }}>
                                  <span style={{
                                      color: 'var(--text-muted)',
                                      fontSize: 'var(--text-sm)'
                                  }}>
                                      Amount to be deducted:
                                  </span>
                                  <span style={{
                                      color: 'var(--primary-orange)',
                                      fontSize: 'var(--text-lg)',
                                      fontWeight: '700'
                                  }}>
                                      ${props.selectedProxy?.lastPaymentC ? (props.selectedProxy.lastPaymentC/100).toFixed(2) : '0.00'}
                                  </span>
                              </div>
                          </div>
                      </div>

                      {/* Кнопки */}
                      <div style={{
                          display: 'flex',
                          gap: 'var(--spacing-md)',
                          justifyContent: 'flex-end'
                      }}>
                          <button
                              onClick={handleClose}
                              className="btn btn-outline"
                              style={{ minWidth: '100px' }}
                          >
                              Cancel
                          </button>
                          <button
                              onClick={handleRenew}
                              className="btn btn-primary"
                              style={{ minWidth: '120px' }}
                          >
                              Renew
                          </button>
                      </div>
                  </div>
              </div>
          )}
      </>
  )
}

export default RenewProxyConfirmDialog